import type { QuizBuilderSectionSchema } from '@repo/schemas/quiz/quizBuilder';

import { useMemo } from 'react';

export function useQuizSettingsOverviewData(sections: QuizBuilderSectionSchema[]) {
  const data = useMemo(() => {
    const data = sections.reduce(
      (acc, section) => {
        const sectionQuestions = section.questions;
        acc.questionsCount += sectionQuestions.length;
        acc.pointsCount += sectionQuestions.reduce((qAcc, question) => qAcc + (question.points || 0), 0);
        return acc;
      },
      { pointsCount: 0, questionsCount: 0 }
    );
    return { ...data, sectionsCount: sections.length };
  }, [sections]);

  return data;
}
